import styled from 'styled-components';
import { typeStyle } from '../../../styles/typeStyle';
import type { FontWeight } from '../../../styles/variables';
import type { ParagraphType } from './Paragraph.data';

export interface StyledParagraphProps {
  $type: ParagraphType;
  $fontWeight?: FontWeight;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const StyledParagraph = styled.p<StyledParagraphProps>`
  ${(props) => typeStyle[props.$type]};

  ${(props) => props.$fontWeight && `font-weight:  ${props.$fontWeight}`};
`;
